import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/AxiosConfig';

// ** Generic Fetch Mcode
export const getMcode = createAsyncThunk(
  'mcode/getMcode',
  async (params) => {
    const response = await axios.get('/api/mcode', { params });
    return response.data; // Return both type and data
  }
);

// ** Initial State with individual loading state
const initialState = {
  data: {},
  error: null,
  status: 'idle',
};

const mcodeSlice = createSlice({
  name: 'mcode',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getMcode.pending, (state, action) => {
        state.status = 'loading'; // Set loading for specific type
        state.error = null;
      })
      .addCase(getMcode.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.status = 'succeeded'; // Set loading for specific type
        state.data = data;
        state.error = null;
      })
      .addCase(getMcode.rejected, (state, action) => {
        state.status = 'failed'; // Set loading for specific type
        state.error = action.error.message;
      });
  },
});

export default mcodeSlice.reducer;